import headerLogo from '../assets/images/headerLogo.png'

export default function Footer() {
  return (
    <footer className="bg-black text-white px-6 py-12">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
        
        {/* Logo */}
        <div className="flex flex-col items-start">
          <a href="#hjem" className="flex items-center gap-2">
            <img src={headerLogo} alt="logo" className="w-32 mb-4" />
          </a>
        </div>

        {/* Navigation Links */}
        <div className="flex flex-col sm:flex-row sm:space-x-12 space-y-2 sm:space-y-0">
          <a href="#hjem" className="hover:underline">Hjem</a>
          <a href="#om-oss" className="hover:underline">Om oss</a>
          <a href="#salgsarenaer" className="hover:underline">Salgsarenaer</a>
          <a href="#arrangementer" className="hover:underline">Arrangementer</a>
          <a href="#kontakt" className="hover:underline">Kontakt</a>
        </div>
      </div>

      {/* Divider */}
      <hr className="my-8 border-gray-700" />

      {/* Bottom Bar */}
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row justify-between items-center text-sm text-gray-400 gap-2 sm:gap-0">
        <p>©2025 Visit Krokeide UB. All rights reserved.</p>
      </div>
    </footer>
  );
}
